































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class InputFile extends Vue {
  @Prop({ required: true, default: '' }) private id!: string
  @Prop({ required: true, default: [] }) private value!: File[]
  @Prop({ required: true, default: false }) private hasError!: boolean

  private get localValue() {
    return this.value || []
  }

  private emitFiles(v: File[]) {
    this.$emit('input', v)
  }

  private onFileInputClick(id: string) {
    const target = document.getElementById(id) as HTMLInputElement
    target.click()
  }

  private imgUrl(file: File) {
    const blob = new Blob([file], { type: file.type })
    return URL.createObjectURL(blob)
  }
}
